<template>
  <van-nav-bar
    :title="title"
    left-arrow
    fixed
    placeholder
    class="aroma-secondary-nav"
    @click-left="goBack"
    @click-right="$emit('click-right')"
  >
    <template v-if="rightIcon || rightText" #right>
      <button class="aroma-secondary-nav__action" type="button" @click.stop="$emit('click-right')">
        <van-icon v-if="rightIcon" :name="rightIcon" class="aroma-secondary-nav__right" />
        <span v-if="rightText">{{ rightText }}</span>
      </button>
    </template>
  </van-nav-bar>
</template>

<script>
import { Icon, NavBar } from 'vant'

export default {
  name: 'AromaSecondaryNav',

  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon
  },

  props: {
    title: {
      type: String,
      required: true
    },
    fallback: {
      type: String,
      default: ''
    },
    fallbackQuery: {
      type: Object,
      default: () => ({})
    },
    rightIcon: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    browserBackOnly: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    goBack () {
      if (this.browserBackOnly) {
        if (window.history.length > 1) {
          this.$router.back()
        } else if (window.WeixinJSBridge && typeof window.WeixinJSBridge.call === 'function') {
          window.WeixinJSBridge.call('closeWindow')
        } else {
          window.history.back()
        }
        return
      }
      if (window.history.length > 1) {
        this.$router.back()
        return
      }
      if (this.$route.name === 'AromaReportLogin' && !this.$route.query.sn) {
        if (window.WeixinJSBridge && typeof window.WeixinJSBridge.call === 'function') {
          window.WeixinJSBridge.call('closeWindow')
          return
        }
        window.close()
      }
      if (this.fallback) {
        const sn = this.$route.query.sn || ''
        this.$router.replace({
          name: this.fallback,
          query: Object.keys(this.fallbackQuery).length ? this.fallbackQuery : sn ? { sn } : {}
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-secondary-nav {
  z-index: 20;
  border-bottom: 1px solid #eceef2;

  ::v-deep .van-nav-bar__title {
    color: #24304a;
    font-size: 17px;
    font-weight: 600;
  }

  ::v-deep .van-icon {
    color: #596afd;
  }

  &__action {
    display: inline-flex;
    min-width: 40px;
    min-height: 30px;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 0 5px;
    border: 0;
    border-radius: 5px;
    color: #596afd;
    background: #f0f2ff;
    font-size: 12px;
    line-height: 22px;
    touch-action: manipulation;
  }

  &__action:active {
    background: #e4e8ff;
  }

  &__right {
    font-size: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .aroma-secondary-nav__action { transition: none; }
}
</style>
